<div fxLayout="row" fxLayoutAlign="start center">
  <topo-color-display [htmlColorCode]="colorCode" [showHtmlColorCode]="false"></topo-color-display>
  <span class="ml-2">{{ workflowStatus }}</span>
</div>
